import { motion } from "framer-motion";
import { ShieldCheck, CurrencyDollar, Handshake, Lightning } from "@phosphor-icons/react";

const REASONS = [
  {
    icon: ShieldCheck,
    title: "No Upselling — Ever",
    description: "We never charge for work that doesn't need to be done. If your car is fine, we'll tell you straight up.",
    span: "md:col-span-7",
  },
  {
    icon: CurrencyDollar,
    title: "Accurate Estimates",
    description: "Our quotes are 100% accurate and we frequently come in under estimate. No hidden fees, no surprises.",
    span: "md:col-span-5",
  },
  {
    icon: Handshake,
    title: "Budget-Friendly Options",
    description: "We source quality refurbished parts when possible, helping keep your car safe and your finances intact.",
    span: "md:col-span-5",
  },
  {
    icon: Lightning,
    title: "Fast & Accommodating",
    description: "Despite staying busy, we squeeze in same-day appointments for minor issues and emergencies whenever we can.",
    span: "md:col-span-7",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.12 },
  }),
};

export default function WhyChooseUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="uppercase text-xs tracking-[0.2em] text-muted-foreground font-medium mb-4"
        >
          Why Choose Us
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-none mb-16 max-w-xl"
        >
          The kind of mechanic you <span className="text-primary">actually trust</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {REASONS.map((reason, i) => (
            <motion.div
              key={reason.title}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={cardVariants}
              className={`${reason.span} bg-card border border-stone-200 rounded-xl p-8 md:p-10 group hover:border-primary/30 transition-colors duration-300`}
              data-testid={`why-us-card-${i}`}
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                <reason.icon weight="duotone" className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-heading font-bold text-xl mb-3 tracking-tight">{reason.title}</h3>
              <p className="text-muted-foreground leading-relaxed text-sm md:text-base">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
